export const getPartnerInstance = (state: any) => state.partnerInstance.partnerInstance.data;
